import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { IBlogPostMeta } from '../../interfaces/blog-post.interface';

@Component({
  selector: 'app-blog-card',
  imports: [CommonModule, RouterLink],
  templateUrl: './blog-card.html',
  styleUrl: './blog-card.scss',
})
export class BlogCard {
  @Input() post!: IBlogPostMeta;

  get categoryLabel(): string {
    return this.post.category_names?.[0] || 'Uncategorized';
  }

  get formattedDate(): string {
    if (!this.post.date) return '';
    return new Date(this.post.date).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  }
}
